import Profile from '@advisor/models/store/user/profile';

export default class User {
  constructor() {
    this.profile = new Profile();

    this.id = null;
    this.accessToken = null;
    this.expiresIn = null;
    this.refreshToken = null;
    this.riaId = null;
    this.scope = null;
    this.tokenType = null;
    this.type = null;
    this.riaGroupId = null;
  }
}
